// Full jitter — random across the whole capped window, not around it: one BFF or LB
// event otherwise puts every client in lockstep.
export function backoffDelayMs(attempt: number, baseMs: number, capMs: number): number {
  return Math.random() * Math.min(baseMs * 2 ** (attempt - 1), capMs);
}
